import { Fragment, HTMLAttributes, ReactNode, useId } from 'react';
import { twMerge } from 'tailwind-merge';
import { TagStyleVariants } from '../../atoms/tag/variants';
import { Tag, Typography } from '../../ui';

type Props = {
  title: string;
  subtitle?: string;
  icon?: ReactNode;
  actions?: Array<ReactNode>;
  alignIcon?: boolean;
  status?: {
    label: string;
    size?: TagStyleVariants['size'];
    variant?: TagStyleVariants['variant'];
  };
} & Omit<HTMLAttributes<HTMLDivElement>, 'status'>;

export function CardHeader(props: Props) {
  const id = useId();
  const {
    title,
    subtitle,
    icon,
    actions,
    className,
    alignIcon = false,
    status,
    ...rest
  } = props;

  return (
    <div className={twMerge('flex flex-row space-x-12', className)} {...rest}>
      <div
        className={twMerge(
          'flex flex-row space-x-12 flex-1',
          alignIcon && 'items-center',
        )}
      >
        {icon && icon}

        <div className="flex flex-col">
          <Typography
            variant="body-xs"
            weight="medium"
            className="text-grayscale600 block truncate max-w-[200px]"
          >
            {title}
          </Typography>

          {subtitle && (
            <Typography
              variant="body-xs"
              weight="regular"
              className="text-grayscale300 block truncate max-w-[200px]"
            >
              {subtitle}
            </Typography>
          )}
        </div>
      </div>

      <div className="flex flex-row space-x-12">
        {status && <Tag {...status} />}

        {actions?.map((action, key) => (
          <Fragment key={`card-header-${id}-action-${key}`}>{action}</Fragment>
        ))}
      </div>
    </div>
  );
}
